import { cn } from "tools/ui";

function FrontTabs({ tabs, selectedTab, component, globalSearch }) {
  function onClick(tab) {
    const currentTab = tabs[tab.id];
    selectedTab.value = tab.id;
    component.value = currentTab.Component;
  }

  return (
    <div className="mt-4  w-full">
      <nav
        aria-label="Tabs"
        className="flex max-md:flex-nowrap items-start md:space-x-6 w-full max-md:overflow-x-auto max-md:px-3 max-md:pb-3"
      >
        {Object.values(tabs).map((tab) => (
          <button
            type="button"
            id={tab.id}
            key={tab.name}
            onClick={() => onClick(tab)}
            className={cn(
              "max-md:w-1/3 md:w-30 max-md:shrink-0 rounded-md px-3 py-2 text-sm font-medium h-ull",
              selectedTab.value === tab.id
                ? "bg-blue-100 text-neutral-700 border border-neutral-400"
                : "text-neutral-500 hover:bg-neutral-200 hover:text-neutral-600",
            )}
          >
            {tab.Icon}
            {tab.name}
          </button>
        ))}
      </nav>
      {<component.value globalSearch={globalSearch} />}
    </div>
  );
}

export default FrontTabs;
